export default __webpack_public_path__ + "static/media/comment_btn.85ef3ad0.svg";